import { Pipe, PipeTransform } from '@angular/core';
import { PhoneMask } from './phonemask';

@Pipe({
  name: 'formatPhone'
})
export class FormatPhonePipe implements PipeTransform {

  transform(value: any, ...args: any): unknown {
    if (value == null || value.trim().length == 0) return "";

    try {
      var rest = "";
      var formated = "";

      var prefix = PhoneMask.getMatch(value);

      if (prefix != null) {
        prefix = "+" + prefix;
        rest = value.substr(prefix.length);
        formated = prefix;
      }
      else {
        rest = value;
      }

      formated += " " + rest.substr(0, 3);
      formated += " " + rest.substr(3, 3);
      formated += " " + rest.substr(6);

      return formated;
    }
    catch (e) {
      return value;
    }
  }

}
